var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('b-loading',{attrs:{"is-full-page":_vm.isFullPage,"can-cancel":true},model:{value:(_vm.isLoading),callback:function ($$v) {_vm.isLoading=$$v},expression:"isLoading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }